import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

let _userManager: UserManager | null = null;

export const initUserManager = (authority: string, clientId: string) => {
    _userManager = new UserManager({
        authority,
        client_id: clientId,
        redirect_uri: window.location.origin + '/',
        post_logout_redirect_uri: window.location.origin + '/',
        scope: 'email offline_access openid profile authentik_pk',
        response_type: 'code',
        automaticSilentRenew: true,
        userStore: new WebStorageStateStore({ store: window.localStorage }),
    });
    return _userManager;
};

export const getUserManager = (): UserManager => {
    if (!_userManager) {
        throw new Error('OIDC UserManager not initialized. Call initUserManager() first.');
    }
    return _userManager;
};
